/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Test
 * test for applicants to analytics team
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MultipleChoiceAnswerCreatePayloadRequest
 */
export interface MultipleChoiceAnswerCreatePayloadRequest {
    /**
     * 
     * @type {string}
     * @memberof MultipleChoiceAnswerCreatePayloadRequest
     */
    text: string;
    /**
     * 
     * @type {boolean}
     * @memberof MultipleChoiceAnswerCreatePayloadRequest
     */
    correct: boolean;
    /**
     * 
     * @type {number}
     * @memberof MultipleChoiceAnswerCreatePayloadRequest
     */
    question: number;
}

/**
 * Check if a given object implements the MultipleChoiceAnswerCreatePayloadRequest interface.
 */
export function instanceOfMultipleChoiceAnswerCreatePayloadRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "text" in value;
    isInstance = isInstance && "correct" in value;
    isInstance = isInstance && "question" in value;

    return isInstance;
}

export function MultipleChoiceAnswerCreatePayloadRequestFromJSON(json: any): MultipleChoiceAnswerCreatePayloadRequest {
    return MultipleChoiceAnswerCreatePayloadRequestFromJSONTyped(json, false);
}

export function MultipleChoiceAnswerCreatePayloadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MultipleChoiceAnswerCreatePayloadRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'text': json['text'],
        'correct': json['correct'],
        'question': json['question'],
    };
}

export function MultipleChoiceAnswerCreatePayloadRequestToJSON(value?: MultipleChoiceAnswerCreatePayloadRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'text': value.text,
        'correct': value.correct,
        'question': value.question,
    };
}

